class StickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.trigger = document.querySelector(this.dataset.trigger);
    this.priceSource = document.querySelector(this.dataset.priceSource);
    this.priceTarget = this.querySelector('[data-sticky-price]');

    if (!this.trigger) return;

    this.syncPrice();

    // Gewählte Variante mitschreiben, damit klar ist, was im Warenkorb landet
    this.auswahl = this.querySelector('[data-sticky-auswahl]');
    this.varianten = document.querySelector('variant-selects');
    if (this.auswahl && this.varianten) {
      this.varianten.addEventListener('change', () => requestAnimationFrame(() => this.syncAuswahl()));
    }

    if (this.priceSource) {
      this.priceObserver = new MutationObserver(() => this.syncPrice());
      this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
    }

    this.update = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const passed = this.trigger.getBoundingClientRect().bottom < 0;
        this.classList.toggle('sticky-buy-bar--visible', passed);
      });
    };

    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    this.priceObserver?.disconnect();
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  syncAuswahl() {
    const werte = [...this.varianten.querySelectorAll('fieldset, select')].map((el) =>
      el.tagName === 'SELECT' ? el.value : el.querySelector('input[type="radio"]:checked')?.value
    );
    this.auswahl.textContent = werte.filter(Boolean).map((w) => ` · ${w}`).join('');
  }

  syncPrice() {
    if (!this.priceSource || !this.priceTarget) return;
    const regular = this.priceSource.querySelector('.price-item--regular, .price-item--sale');
    this.priceTarget.textContent = (regular || this.priceSource).textContent.trim();
  }
}

customElements.define('sticky-buy-bar', StickyBuyBar);
